/**
 * 通常入札タブで札を追加できない時、 グラフ / コマをクリックして開く理由モーダルの本文 key を決める純関数。
 *
 * 締切の本文 (AC-BSP-064) は締切後だけに出す。 読み取り専用 (ワークフローの取得中・失敗、
 * 完了・削除済みのワークフローから開いた時) は締切前にも起こるため、 締切の本文を出すと
 * 実際と違う理由を示すことになる。 完了・削除済みの理由文 (readonlyReason) がある時は
 * 呼び出し側がそれを優先して出す。
 */

export type BidCreateDisabledReason =
  | 'deadline'
  | 'readonly'
  | 'approvalFlowUnavailable'
  | 'focused'

export const bidCreateLockModalBodyKey = (
  reason: BidCreateDisabledReason,
): string => {
  switch (reason) {
    case 'deadline':
      return 'page:biddingSpot.editLockModal.body'
    case 'readonly':
      return 'page:biddingSpot.editLockModal.readonlyBody'
    case 'approvalFlowUnavailable':
      return 'page:biddingSpot.editLockModal.approvalFlowUnavailableBody'
    case 'focused':
      return 'page:biddingSpot.editLockModal.focusedBody'
  }
}
